module.exports = __webpack_public_path__ + "media/images/PDF-icon-1aeac20530c9d17514ac501525108b1f.png";